/* import __COLOCATED_TEMPLATE__ from './confirm.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { getSvgNameForCategory } from '@banking/api/utils/bank-account';
import { inject as service } from '@ember/service';
import { Action, getEvent, Page, Target } from '@banking/ui/utils/folder-cdp-events';
let Confirm = (_dec = computed('automationSubaccountState.targetAmount.amount'), _dec2 = computed('automationSubaccountState.category'), _class = class Confirm extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _defineProperty(this, "goBack", void 0);
    _defineProperty(this, "continue", void 0);
  }
  didInsertElement() {
    super.didInsertElement();
    const {
      name,
      properties
    } = getEvent(Action.View, {
      page: Page.ConfirmNewFolder
    });
    this.dataApi.track(name, properties);
  }
  get hasTarget() {
    const targetAmount = this.automationSubaccountState?.targetAmount?.amount;
    return targetAmount && targetAmount > 0;
  }
  get svgName() {
    return getSvgNameForCategory(this.automationSubaccountState.category);
  }
  _continue() {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.ConfirmNewFolder,
      target: Target.LooksGood
    });
    this.dataApi.track(name, properties);
    this.continue();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasTarget", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "hasTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "svgName", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "svgName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_continue"), _class.prototype), _class);
export { Confirm as default };